import 'babel-polyfill'
import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Theme } from 'stylist'
import 'normalize.css'
import global from 'styles/global'
import { BrowserRouter } from 'react-router-dom'
import store from './config/store'
import { Provider } from 'react-redux'
import './config/sentry'

document.body.style.backgroundColor = 'rgba(228, 232, 235, 0.7)'

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Theme theme={'forsta'}>
        {global()}
        <App />
      </Theme>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js